import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { ResponsavelVO } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class ResponsavelService {

  constructor(private readonly http: McticHttpClient) {
  }

  obterPorComposicao(idComposicaoRda: number) {
    return this.http.get<ResponsavelVO[]>(`/sepin-backend/rest/composicoes-rda/${idComposicaoRda}/responsaveis`);
  }

}
